export const iconFontAwesomeFilesPaste = (
	<i className="fa-solid fa-paste"></i>
);
